import type { AxisPositions } from "../types";

import { EndLine, Line, LineWrapper, NumberValue, NumberWrapper, StartLine } from "./styles";

type AxisLineProps = {
    axisPositions?: AxisPositions;
    lineBackgroundColor?: string;
};

const AxisLine = ({ axisPositions, lineBackgroundColor }: AxisLineProps) => (
    <LineWrapper>
        <StartLine />
        <NumberWrapper isStart>
            <NumberValue>{axisPositions?.minDot.count}</NumberValue>
        </NumberWrapper>
        <Line background={lineBackgroundColor} />
        <EndLine />
        <NumberWrapper isStart={false}>
            <NumberValue>{axisPositions?.maxDot.count}</NumberValue>
        </NumberWrapper>
    </LineWrapper>
);

export default AxisLine;
